import React from 'react'
import { faBell } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../Style/style.css'

export default function Header() {
    return (
        <header>
            <div className='flex items-center justify-between px-3 lg:px-10 py-4'>
                <div className='w-[50%] lg:w-[20%]'>
                    <img src='/assets/logo/GLX_NEW_WT BG_Low.png' className='w-40'></img>
                </div>
                <div className='w-[50%] lg:w-[80%] flex justify-end lg:justify-between items-center'>
                    <div className='text-white hidden lg:block'>
                        <p className='text-lg'>Welcome to <span className='font-bold'>Goaldex</span></p>
                        <p className='text-sm'>Hello <span className='font-bold'>Admin !</span></p>
                    </div>
                    <button className='w-7 lg:w-10 h-7 lg:h-10 bg-white rounded-full grid place-content-center lg:text-lg cursor-pointer notify-bell'>
                        <FontAwesomeIcon icon={faBell} className='text-[#5C1FE2] ' />
                    </button>
                </div>
            </div>
        </header>
    )
}
